import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[datafieldHost]'
})
export class DatafieldDirective {
	constructor(public viewContainerRef: ViewContainerRef) {}
}
